export default __webpack_public_path__ + "static/media/user_icn.8fd5355d.svg";